import { OFFER_KIND } from '../../../../../../views/menu/offers/constants';

export default {
  title: 'Tarjouksen tiedot',
  types: {
    [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: {
      title: 'Aseta vaadittu kulutus ja alennusprosentti',
      qualifying_criteria: {
        title: 'Vähimmäisostosumma',
        description: 'Aseta vaadittu kulutusmäärä',
      },
      details: {
        title: 'Alennusprosentti',
        description: 'Aseta alennusmäärä, jonka asiakkaat saavat tilauksestaan',
      },
    },
    [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: {
      title: 'Aseta vaadittujen tuotteiden ostosumma ja alennusprosentti',
      qualifying_criteria: {
        title: 'Alennetut tuotteet',
        description: 'Valitse tuotteet, joille tarjoat alennuksen.',
      },
      details: {
        title: 'Alennusprosentti',
        description: 'Aseta alennusmäärä, jonka asiakkaat saavat tilauksestaan',
      },
    },
    [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: {
      title: 'Aseta vaaditut tuotteet ja {{currency}}-alennus',
      qualifying_criteria: {
        title: 'Alennetut tuotteet',
        description: 'Valitse tuotteet, joille tarjoat alennuksen.',
      },
      details: {
        title: '{{currency}}-alennus',
        description: 'Aseta alennusmäärä, jonka asiakkaat saavat tilauksestaan',
      },
    },
    [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: {
      title: 'Aseta vaadittu kulutus ja {{currency}}-alennus',
      qualifying_criteria: {
        title: 'Vähimmäisostosumma',
        description: 'Aseta vaadittu kulutusmäärä',
      },
      details: {
        title: '{{currency}}-alennus',
        description: 'Aseta alennusmäärä, jonka asiakkaat saavat tilauksestaan',
      },
    },
    [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: {
      title: 'Aseta vaadittu kulutus ja ilmaiset tuotteet',
      qualifying_criteria: {
        title: 'Vähimmäisostosumma',
        description: 'Aseta summa, jonka asiakkaan tulee käyttää saadakseen ilmaisen tuotteen.',
      },
      details: {
        title: 'Ilmaiset tuotteet:',
        description: 'Valitse ilmainen tuote (tai tuotteet), joista asiakas voi valita yhden.',
      },
    },
    [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: {
      title: 'Valitse tarjouksen vaatimukset',
      qualifying_criteria: {
        title: 'Vaaditut tuotteet',
        description: 'Valitse tuotteet, jotka asiakkaan tulee tilata saadakseen ilmaisen tuotteen.',
      },
      details: {
        title: 'Ilmaiset tuotteet:',
        description: 'Valitse ilmainen tuote (tai tuotteet), joista asiakas voi valita yhden.',
      },
    },
    [OFFER_KIND.BOGO]: {
      title: 'Valitse tarjouksen vaatimukset',
      qualifying_criteria: {
        title: 'Vaaditut tuotteet',
        description: 'Valitse kategoria, josta asiakkaan tulee valita saadakseen ilmaisen tuotteen.',
      },
      details: {
        title: 'Ilmainen tuote',
        description:
          'Asiakkaat voivat valita toisen tuotteensa valitsemistasi vaaditusta tuotteista. Asiakas saa halvemman näistä kahdesta tuotteesta ilmaiseksi.',
      },
    },
  },
};
